import CustomDownloadComponent from "../../../components/FileDownload/CustomDownloadComponent";
import UploadedDocuments from "../../../components/UploadedDocuments/UploadedDocuments";
import { UploadedDocumentData } from "../UserData";

const CompanyDetails = ({ FloorCaseDetails, GetOwnerType }) => {
  const AddLabelToFile = (arr, value) => {
    //console.log("Document", value);
    return {
      label: value,
      files: arr,
    };
  };
  const CompanyInfo = FloorCaseDetails?.companyInfo;
  //console.log("CompanyInfo", CompanyInfo)

  const Company_ACRA = UploadedDocumentData[0].files;

  return (
    <section>
      {/* Application Preview */}
      <div className="preview-list-block">
        <div className="preview-list-group">
          <div className="preview-list">
            <h3>Company Name:</h3>
            <p>{CompanyInfo?.company}</p>
          </div>
          <div className="preview-list">
            <h3>Company UEN:</h3>
            <p>{CompanyInfo?.UEN?.replace(/\d(?=(?:\D*\d){3})/g, "x")}</p>
          </div>
        </div>
      </div>

      {/* Point of Contact #1 */}
      <div className="preview-list-block">
        <h2 className="preview-subheading">Point of Contact #1</h2>
        <div className="preview-list-group">
          <div className="preview-list">
            <h3>Name:</h3>
            <p>{CompanyInfo?.poc1_name}</p>
          </div>
          <div className="preview-list">
            <h3>Email:</h3>
            <p>{CompanyInfo?.poc1_email}</p>
          </div>
          <div className="preview-list">
            <h3>Contact No:</h3>
            <p>{CompanyInfo?.poc1_contactno}</p>
          </div>
        </div>
      </div>

      {/* Point of Contact #2 */}
      <div className="preview-list-block">
        <h2 className="preview-subheading">Point of Contact #2</h2>
        <div className="preview-list-group">
          <div className="preview-list">
            <h3>Name:</h3>
            <p>{CompanyInfo?.poc2_name}</p>
          </div>
          <div className="preview-list">
            <h3>Email:</h3>
            <p>{CompanyInfo?.poc2_email}</p>
          </div>
          <div className="preview-list">
            <h3>Contact No:</h3>
            <p>{CompanyInfo?.poc2_contactno}</p>
          </div>
        </div>
      </div>


      {/* Uploaded Documents */}
      <div className="preview-list-block">
        <div className="download-block">
          <h2 className="preview-subheading">Document (s) Uploaded</h2>
          <CustomDownloadComponent type="Flooring-Company-Details" appId={FloorCaseDetails?.vehicleInfo?.id} formType={"Company_ACRA"} />
        </div>
        <div className="preview-list-group">
          <UploadedDocuments
            documents={AddLabelToFile(
              FloorCaseDetails?.Company_ACRA,
              "Company ACRA Document(s)"
            )}
          />
        </div>
      </div>
    </section>
  );
};
export default CompanyDetails;
